import httpService from '@/utils/http-service'

const module = 'staff'
const controller = 'home'

export function countPendingEvent() {
	return httpService.request({
		url: `${module}/${controller}/countPendingEvent`,
		loading: false
	})
}

export function countMessage() {
	return httpService.request({
		url: `${module}/${controller}/countMessage`,
		loading: false
	})
}

